import { computed } from 'vue'

import type {
  GetNotificationsResponse,
} from '@/types/api/customer/Notification'
import type { UserDisplayMode } from '@/constants/enums/UserDisplayMode'
import type { FetchContext } from 'ofetch'

import { useApiForCustomer } from '@/composables/useApi'

export const useGetNotifications = (userDisplayMode: ComputedRef<UserDisplayMode>) => {
  const { t } = useI18n()
  return useApiForCustomer<GetNotificationsResponse>('/rest/notifications', {
    method: 'GET',
    query: computed(() => ({
      userDisplayMode: userDisplayMode.value.toUpperCase(),
    })),
    watch: [userDisplayMode],
    onResponse({ response }: FetchContext) {
      if (!response?.ok) {
        alert(t('common.error.code_9999'))
      }
    },
  })
}

export const useReadNotification = (notificationId: string) => {
  return useApiForCustomer<unknown>(`/rest/notifications/${notificationId}/read`, {
    method: 'POST',
    immediate: false,
  })
}
